// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2862":"04069780","8665":"b9db9651","8827":"b9db9651"}[chunkId] + ".chunk.css";
};